<template>
    <SideNav ref="sidenav" :check-close="onCheckClose" class="profile">
        <div class="header">
            <div class="corner">
                <div class="corner-inner">
                    <div class="back"></div>
                    <div class="title">Пользователь {{ currentUser().email }}</div>
                </div>
            </div>

            <div class="adhoc">
                <div class="adhoc-wrapper">
                    <div class="adhoc-content">
                        <div class="close" @click="$refs.sidenav.cancel()"></div>
                    </div>
                </div>
            </div>
        </div>

        <ChangeProfile ref="changeProfile"
                       class="side-nav-inner"
                       @close="close"
                       @changed="changed = $event"
                       @logout="logout" />
    </SideNav>
</template>

<script>
import { currentUser, hasRoles } from '@/common/session.js';
import { logout } from '@/restapi/user/user.js';
import { showConfirm } from '@dsee/components/popups/confirm.js';
import ChangeProfile from './ChangeProfile.vue';


export default {
    name: 'Profile',
    components: {
        ChangeProfile,
    },
    data() {
        return {
            changed: false,
        };
    },
    computed: {
    },
    methods: {
        currentUser,
        open() {
            this.$refs.changeProfile.reset();
            this.$refs.sidenav.open();
        },
        close() {
            this.$refs.sidenav.accept();
        },
        async logout() {
            const resp = await showConfirm({
                title: 'Выход',
                text: 'Хотите завершить работу?',
                buttons: [
                    {
                        title: 'Выйти',
                        value: 1,
                        class: 'primary',
                    },
                    {
                        title: 'Отмена',
                        value: 0,
                    },
                ],
            });

            if (!resp)
                return;

            await logout();
            this.$router.push({ name: 'login' });
        },
        onCheckClose(sidenav) {
            if (!this.changed)
                return true;

            return sidenav.showConfirm();
        },
    },
};
</script>

<style lang="scss" scoped>

.profile {
    .header {
        flex-wrap: nowrap;
    }

    .content {
        :deep(.middle) {
            padding-top: 20px;
            padding-bottom: 20px;
            height: 100%;
        }

        :deep(.footer) {
            height: 76px;
            box-sizing: border-box;
        }
    }

    :deep(.content.side-nav-inner) {
        @media (max-device-width: 767px) {
            &:not(.change-profile, .available-cards) > * {
                padding: 0;
            }

            & > .header {
                padding: 20px;
            }
        }
    }
}
</style>
